import { Tooltip, Typography } from '@mui/material';
import { FC, ReactNode, useRef, useState } from 'react';

const EllipsisTypography: FC<{ children: ReactNode }> = ({ children }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLSpanElement>(null);

  return (
    <Tooltip
      title={children}
      placement="bottom-start"
      open={open}
      onClose={() => {
        setOpen(false);
      }}
    >
      <Typography
        ref={ref}
        variant="h6"
        onMouseEnter={() => {
          if (ref.current) {
            setOpen(ref.current.scrollWidth > ref.current.clientWidth);
          }
        }}
      >
        {children}
      </Typography>
    </Tooltip>
  );
};

export default EllipsisTypography;
